"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var styles_1 = require("./styles");
var FilterPopover = function (_a) {
    var filterList = _a.filterList, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(styles_1.CheckboxWrapper, { children: filterList === null || filterList === void 0 ? void 0 : filterList.map(function (_a) {
            var label = _a.label, isChecked = _a.isChecked, value = _a.value, isDisable = _a.isDisable;
            return ((0, jsx_runtime_1.jsx)(styles_1.CheckboxContainer, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { label: label, checked: isChecked, onToggle: function () { return onClick(value); }, disabled: isDisable }) }, "filterlist".concat(label)));
        }) }));
};
exports.default = FilterPopover;
